import React from 'react';
import {Button, Container, Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {useNavigate} from "react-router-dom";

interface Props {
  session?: any;
}

export const NotFound: React.ComponentType<Props> = ({ session }) => {

  const navigate = useNavigate();

  return (
    <>
      <Stack
        width={'100%'}
        height={'100%'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <Container maxWidth="md">
          <Grid container spacing={2} alignItems={'center'} >
            <Grid xs={12} md={6}>
              <img
                src="https://cdn.pixabay.com/photo/2017/03/09/12/31/error-2129569__340.jpg"
                alt=""
                width={500} height={250}
              />
            </Grid>
            <Grid xs={12} md={6}>
             <Stack gap={1} alignItems={'flex-start'} alignContent={'center'}>
               <Typography variant="h1">
                 404 Not Found
               </Typography>
               <Typography variant="h6">
                 The page you’re looking for doesn’t exist.
               </Typography>
               <Button
                 onClick={()=>{
                   navigate('/');
                 }}
                 variant="contained">Back To Home</Button>
             </Stack>
            </Grid>

          </Grid>
        </Container>
      </Stack>
    </>
  );
};
